(ns common.schema.field
  (:require
   [clojure.string :as string]
   [common.schema.registry :as registry]))

(def MANDATORY-POSITIVE-ATTRIBUTES [:mandatory/always :mandatory/partially])

(defn placeholder
  [field-schema]
  (or (->> field-schema
           :field/translations
           :placeholder
           :en)
      (str "Add "
           (->> field-schema
                :field/translations
                :en
                (str)
                (string/lower-case)))))

(defn tag-field?
  [attribute]
  (string/starts-with? (name attribute) "tag-"))

(defn select-entity-types
  [field-schema]
  (or (:field/select-entity-types field-schema)
      (:field/entity-types field-schema)))

(defn creatable-entity-types
  [entity-types]
  (some->> entity-types
           (remove (fn [et]
                     (contains? #{:entity.type/account
                                  :entity.type/fund
                                  :entity.type/team
                                  :entity.type/webentry
                                  ;; no longer explicit creation:
                                  :entity.type/investor
                                  :entity.type/kpi-category
                                  :entity.type/pipeline}
                                et)))))

(defn create-entity-types
  [field-schema]
  (->> (or (:field/create-entity-types field-schema)
           (select-entity-types field-schema))
       creatable-entity-types))

(defn entity-tag-fields
  [tenant-schema entity-type]
  (->> entity-type
       (registry/get-schema tenant-schema)
       (map first)
       (filter tag-field?)))
